import O1HD from "../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

export interface FakerData {
    node: cc.Node;
    i: number;
    j: number;
    nextList: FakerData[];
}

export interface NeedAddNodeInfo {
    pos: cc.Vec2;
    size: cc.Size;
    color: cc.Color;
}

@ccclass
export default class dfsMode extends cc.Component {

    @property(cc.Node)
    bgNode: cc.Node = null;
    @property(cc.Prefab)
    pFaker: cc.Prefab = null;
    @property()
    maxRows: number = 600;
    @property()
    minRows: number = 1;
    @property()
    maxVel: number = 8;
    @property()
    minVel: number = 1;
    @property(cc.Label)
    lbVel: cc.Label = null;

    onLoad() {
    }

    //
    private m_setVel: number = 1;
    //行列数
    private m_count: number = null;
    //
    private m_needAddNodes: NeedAddNodeInfo[] = [];
    //
    private m_currSetFake: FakerData[][] = [];

    start() {
        this.lbVel.string = `速度:${this.m_setVel}`;
    }

    OnReset() {
        this.bgNode.destroyAllChildren();
        this.m_needAddNodes = [];
    }

    OnShowBfs() {
        //单个大小
        let oneWidth = this.bgNode.width / this.m_count;
        //起点位置
        let startPos = cc.v2(-this.bgNode.width / 2 + oneWidth / 2, -this.bgNode.height / 2 + oneWidth / 2);
        let findResult: cc.Vec2[] = [];
        let tempResult: cc.Vec2[] = [];
        let findTempFake: FakerData[][] = JSON.parse(JSON.stringify(this.m_currSetFake));
        this.OnBfs(findResult, tempResult, findTempFake, this.m_count, 0, 0, startPos, cc.v2(0, 0), cc.v2(this.m_count - 1, this.m_count - 1));
        //
        const wh = oneWidth * 0.8;
        let upLoad: cc.Vec2 = null;
        //
        console.log('结果');
        for (let pos of findResult) {
            if (upLoad != null) {
                let x = (pos.x + upLoad.x) / 2;
                let y = (pos.y + upLoad.y) / 2;
                this.AddNeedAddChildOfFakerPrefab(
                    cc.v2(startPos.x + x * oneWidth, startPos.y + y * oneWidth),
                    cc.size(wh, wh),
                    cc.Color.BLUE,
                );
            }
            this.AddNeedAddChildOfFakerPrefab(
                cc.v2(startPos.x + pos.x * oneWidth, startPos.y + pos.y * oneWidth),
                cc.size(wh, wh),
                cc.Color.BLUE
            )
            upLoad = pos.clone();
        }
    }

    OnShowDfs() {
        //
        this.OnReset();
        //单个大小
        let oneWidth = this.bgNode.width / this.m_count;
        //起点位置
        let startPos = cc.v2(-this.bgNode.width / 2 + oneWidth / 2, -this.bgNode.height / 2 + oneWidth / 2);
        //位置
        this.m_currSetFake = [];
        //
        this.OnDfs(this.m_currSetFake, this.m_count, 0, 0, startPos, oneWidth, cc.v2(0, 0));
    }

    OnBtnAddVel() {
        this.m_setVel = Math.min(this.m_setVel + 1, this.maxVel);
        this.lbVel.string = `速度:${this.m_setVel}`;
    }

    OnBtnLessVel() {
        this.m_setVel = Math.max(this.m_setVel - 1, this.minVel);
        this.lbVel.string = `速度:${this.m_setVel}`;
    }

    OnBtnTest() {
        this.m_count = 10;
        this.OnShowDfs();
    }

    OnBtnAdd() {
        this.m_count = Math.min(this.m_count + 1, this.maxRows);
        this.OnShowDfs();
    }

    OnBtnLess() {
        this.m_count = Math.max(this.m_count - 1, this.minRows);
        this.OnShowDfs();
    }

    OnBtnFind() {
        this.OnShowBfs();
    }

    OnBtnExit() {
        O1HD.getManagers().gameMgr.returnMainScene().then();
    }

    private AddNeedAddChildOfFakerPrefab(pos: cc.Vec2, size: cc.Size, color: cc.Color) {
        //
        this.m_needAddNodes.push({pos, size, color});
    }

    //广度递归寻找
    private OnBfs(
        okFindArrayList: cc.Vec2[],
        currFindArrayList: cc.Vec2[],
        srcFakeArray: FakerData[][],
        maxCount, currX: number, currY: number, startPos: cc.Vec2, firstPos: cc.Vec2, lastPos: cc.Vec2): boolean {
        //
        if (okFindArrayList.length > 0) return;
        //
        if (currX >= maxCount || currX < 0) return;
        if (currY >= maxCount || currY < 0) return;
        //
        currFindArrayList.push(cc.v2(currX, currY));
        //
        if (lastPos.x == currX && lastPos.y == currY) {
            for (let pos of currFindArrayList) {
                okFindArrayList.push(pos.clone());
            }
            return true;
        }
        //
        //顺序下一个
        for (let v2 of srcFakeArray[currX][currY].nextList) {
            if (!this.OnBfs(okFindArrayList, currFindArrayList, srcFakeArray, maxCount, v2.i, v2.j, startPos, firstPos, lastPos)) {
                currFindArrayList.pop();
            }
        }
        return false;
    }

    //深度递归生成
    private OnDfs(currArrayTwo: FakerData[][], maxCount: number, currX: number, currY: number, startPos: cc.Vec2, oneSize: number, firstPos: cc.Vec2, over?: (result: FakerData) => void) {
        //
        if (currX >= maxCount || currX < 0) return;
        if (currY >= maxCount || currY < 0) return;
        //即用即定义
        if (null == currArrayTwo[currX]) {
            currArrayTwo[currX] = [];
        }
        //已存在
        if (currArrayTwo[currX][currY]) {
            over && over(null);
            return;
        }
        //添加
        let sizeWH = oneSize * 0.9;
        this.AddNeedAddChildOfFakerPrefab(cc.v2(startPos.x + oneSize * currX, startPos.y + oneSize * currY), cc.size(sizeWH, sizeWH), cc.Color.WHITE);
        //
        if (firstPos.x != currX || firstPos.y != currY) {
            let posLess = cc.v2((currX + firstPos.x) * 0.5, (currY + firstPos.y) * 0.5);
            this.AddNeedAddChildOfFakerPrefab(cc.v2(startPos.x + posLess.x * oneSize, startPos.y + posLess.y * oneSize), cc.size(sizeWH, sizeWH), cc.Color.WHITE);
        }
        currArrayTwo[currX][currY] = {node: null, i: currX, j: currY, nextList: []};
        //添加
        over && over(currArrayTwo[currX][currY]);
        //随机下一个
        const poss: cc.Vec2[] = [
            cc.v2(-1, 0),
            cc.v2(1, 0),
            cc.v2(0, -1),
            cc.v2(0, 1)
        ];
        //
        while (poss.length > 0) {
            let iPos = Math.floor(Math.random() * poss.length);
            let [{x, y}] = poss.splice(iPos, 1);
            this.OnDfs(currArrayTwo, maxCount, currX + x, currY + y, startPos, oneSize, cc.v2(currX, currY), (result) => {
                if (result) {
                    currArrayTwo[currX][currY].nextList.push(result);
                }
            });
        }
    }

    update(dt) {
        let i = this.m_setVel;
        while (i-- >= 0) {
            const addNode = this.m_needAddNodes.shift();
            if (!addNode) {
                return;
            }
            const {pos, size, color} = addNode;
            //
            let newNode = cc.instantiate(this.pFaker);
            this.bgNode.addChild(newNode);
            newNode.color = color;
            newNode.setPosition(pos);
            newNode.setContentSize(size);
        }
    }
}
